/*
 * Copyright (c) 2014-2023 Comparatio USA  LLC. <https://www.comparatio.com>
 */

import { NgModule } from '@angular/core';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoadingModule } from 'ngx-loading';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPermissionsModule } from 'ngx-permissions';
import { RouterModule } from '@angular/router';

import { routes } from './transactions.routing';
import { TransactionsComponent } from './transactions.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { PipesModule } from '../pipes/pipes.module';
import { MaterialModule } from '../material/material.module';
import { TableModule } from 'primeng/table';
import { TransactionsDetailsComponent } from './transactions-details/transactions-details.component';
import { TransactionsDynamicsComponent } from './transactions-dynamics/transactions-dynamics.component';
import { TransactionsEmailModalComponent } from './transactions-email-modal/transactions-email-modal.component';
import { TransactionsInventoryDownloadComponent } from './transactions-inventory-download/transactions-inventory-download.component';

import { ChartModule, HIGHCHARTS_MODULES } from 'angular-highcharts';
import * as Highcharts from 'highcharts';
import * as more from 'highcharts/highcharts-more.src';
import * as exporting from 'highcharts/modules/exporting.src';
import * as drilldown from 'highcharts/modules/drilldown.src.js';

drilldown(Highcharts);

@NgModule({
  providers: [
    {
      provide: HIGHCHARTS_MODULES,
      useFactory: () => [more, exporting, drilldown, Highcharts],
    }, // add as factory to your providers
  ],
})
export class AppModule {}

import { TransactionsInOutBoundComponent } from './transactions-in-out-bound/transactions-in-out-bound.component';
import { TransactionsTradingPartnerComponent } from './transactions-trading-partner/transactions-trading-partner.component';
import { TransactionsTypeComponent } from './transactions-type/transactions-type.component';
import {TooltipModule} from 'primeng/primeng';

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        NgxPaginationModule,
        NgxDatatableModule,
        LoadingModule,
        CommonModule,
        NgbModule,
        NgMultiSelectDropDownModule,
        NgxPermissionsModule.forChild(),
        RouterModule.forChild(routes),
        PipesModule,
        MaterialModule,
        ChartModule,
        TableModule,
        TooltipModule,
    ],
  exports: [
    TransactionsComponent,
    TransactionsDetailsComponent,
    TransactionsInOutBoundComponent,
    TransactionsTradingPartnerComponent,
    TransactionsTypeComponent,
    TransactionsInventoryDownloadComponent,
  ],
  declarations: [
    TransactionsComponent,
    TransactionsDetailsComponent,
    TransactionsDynamicsComponent,
    TransactionsInOutBoundComponent,
    TransactionsTradingPartnerComponent,
    TransactionsTypeComponent,
    TransactionsEmailModalComponent,
    TransactionsInventoryDownloadComponent,
  ],
})
export class TransactionsModule {}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/transactions/transactions.module.ts